var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessControlIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.698,
    height: 18.476,
    viewBox: "0 0 20.698 18.476",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled-1",
    transform: "translate(0 -0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M5.306,39.74V52.981c0,.2-.343.346-.528.368a29.058,29.058,0,0,1-4.161,0c-.2-.019-.607-.12-.607-.371V39.74h5.3ZM2.595,41.062c-1.7.156-.87,2.848.619,1.924a1.05,1.05,0,0,0-.619-1.924Zm-.163,3.015a1.037,1.037,0,0,0-.014,2.014A1.037,1.037,0,1,0,2.432,44.077Z",
    transform: "translate(-0.009 -36.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M194.306,39.74V52.981c0,.251-.4.351-.607.371a29.059,29.059,0,0,1-4.161,0c-.185-.022-.528-.165-.528-.368V39.74h5.3ZM191.6,41.063a1.055,1.055,0,0,0,.14,2.1A1.055,1.055,0,0,0,191.6,41.063Zm.807,4.761c1.045-1.045-.817-2.592-1.64-1.272A1.047,1.047,0,0,0,192.4,45.824Z",
    transform: "translate(-173.608 -36.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M135.165,39.74V47.4c-.1-.024-.175-.131-.242-.206a48.438,48.438,0,0,1-3.735-4.9c-.337-.535-.59-.8-.007-1.281a7.765,7.765,0,0,1,3.985-1.27Z",
    transform: "translate(-120.172 -36.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M69.991,47.343v-7.66c.882-.079,3.919.785,4.257,1.569.174.4-.073.659-.28.983a49.89,49.89,0,0,1-3.736,4.9c-.067.075-.142.182-.242.206Z",
    transform: "translate(-64.287 -36.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M5.3,2.835H0V.431C0,.267.268.084.444.06c1.321-.18,3.042.146,4.408,0C4.971.009,5.3.3,5.3.35V2.835ZM3.667.8A5.2,5.2,0,0,1,1.63.8V2.02H3.667Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M194.3,2.835H189V.35c0-.05.324-.341.444-.289,1.367.146,3.087-.18,4.408,0,.177.024.444.206.444.371v2.4ZM192.667.8a5.2,5.2,0,0,1-2.037,0V2.02h2.037Z",
    transform: "translate(-173.599 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 4.319,
    height: 1.222,
    transform: "translate(0.489 17.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M199.237,211.74a3.779,3.779,0,0,0,.081,1.222H195V211.74Z",
    transform: "translate(-179.11 -194.482)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControlIcon);
export default __webpack_public_path__ + "static/media/access-control-icon.41ff5b3364fd32e227b16c1133cbeee9.svg";
export { ForwardRef as ReactComponent };